module.exports = __webpack_public_path__ + "img/icon_m_send.1e4b6186.svg";